import { useState, FormEvent } from 'react';

export default function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setSubmitStatus('submitting');

    try {
      const response = await fetch('https://readdy.ai/api/form/d5n9p3vpl7huldvcirh0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams({
          name: formData.name,
          email: formData.email,
          message: formData.message,
        }),
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({ name: '', email: '', message: '' });
        setTimeout(() => setSubmitStatus('idle'), 3000);
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    }
  };

  return (
    <section id="contact" className="py-32 px-8 lg:px-16 bg-white">
      <div className="max-w-lg mx-auto">
        <h2 className="text-4xl lg:text-5xl font-light text-center text-[#2C2C2C] mb-12" style={{ fontFamily: 'Georgia, serif' }}>
          Connect
        </h2>

        <form onSubmit={handleSubmit} className="space-y-6" data-readdy-form id="contact-form">
          {/* Name Field */}
          <div>
            <label htmlFor="name" className="block text-xs uppercase tracking-wider text-[#6B6B6B] mb-2">
              Name
            </label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={(e) => setFormData({ ...formData, name: e.target.value })}
              required
              className="w-full bg-transparent border-b border-[#A8B5A0] py-4 text-base text-[#2C2C2C] focus:outline-none focus:border-[#7A8A72] transition-colors duration-300"
              placeholder="Your name"
            />
          </div>

          {/* Email Field */}
          <div>
            <label htmlFor="email" className="block text-xs uppercase tracking-wider text-[#6B6B6B] mb-2">
              Email
            </label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={(e) => setFormData({ ...formData, email: e.target.value })}
              required
              className="w-full bg-transparent border-b border-[#A8B5A0] py-4 text-base text-[#2C2C2C] focus:outline-none focus:border-[#7A8A72] transition-colors duration-300"
              placeholder="your@email.com"
            />
          </div>

          {/* Message Field */}
          <div>
            <label htmlFor="message" className="block text-xs uppercase tracking-wider text-[#6B6B6B] mb-2">
              Message
            </label>
            <textarea
              id="message"
              name="message"
              value={formData.message}
              onChange={(e) => setFormData({ ...formData, message: e.target.value })}
              required
              maxLength={500}
              rows={4}
              className="w-full bg-transparent border-b border-[#A8B5A0] py-4 text-base text-[#2C2C2C] focus:outline-none focus:border-[#7A8A72] transition-colors duration-300 resize-none"
              placeholder="Share your thoughts..."
            />
            <p className="text-xs text-[#9B9B9B] mt-1">{formData.message.length}/500</p>
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            disabled={submitStatus === 'submitting'}
            className="w-full bg-[#A8B5A0] text-white py-4 rounded-[28px] text-base hover:bg-[#93A38C] transition-all duration-300 cursor-pointer disabled:opacity-50 whitespace-nowrap"
          >
            {submitStatus === 'submitting' ? 'Sending...' : 'Send Message'}
          </button>

          {/* Status Messages */}
          {submitStatus === 'success' && (
            <p className="text-center text-[#A8B5A0] text-sm">Thank you for reaching out! We'll be in touch soon.</p>
          )}
          {submitStatus === 'error' && (
            <p className="text-center text-red-500 text-sm">Something went wrong. Please try again.</p>
          )}
        </form>
      </div>
    </section>
  );
}